import { type NaicsCodeId } from "@inrev/common";
import { Control, Controller, FieldValues, Path } from "react-hook-form";
import { NAICSCodeSelectInput, NAICSCodeSelectInputProps } from "../inputs/NAICSCodeSelectInput";

export type FormNAICSCodeSelectProps<
	TFieldValues extends FieldValues,
	TTransformedValues = TFieldValues,
> = Omit<
	NAICSCodeSelectInputProps,
	"value" | "error" | "onChange" | "subsetFilters" | "defaultSubsetIndex" | "allNAICSCodesLabel"
> & {
	// biome-ignore lint/suspicious/noExplicitAny: legacy any
	control: Control<TFieldValues, any, TTransformedValues>;
	name: Path<TFieldValues>;
	errorMessage?: string;
	subsetFilters?: [
		{ label: string; subset: NaicsCodeId[] },
		...{ label: string; subset: NaicsCodeId[] }[],
	];
	defaultSubsetIndex?: number;
	allNAICSCodesLabel?: string;
	inline?: boolean;
} & (
		| {
				subsetFilters: [
					{ label: string; subset: NaicsCodeId[] },
					...{ label: string; subset: NaicsCodeId[] }[],
				];
				defaultSubsetIndex?: number;
				allNAICSCodesLabel: string;
		  }
		| {
				subsetFilters?: undefined;
				defaultSubsetIndex?: undefined;
				allNAICSCodesLabel?: undefined;
		  }
	);

export const FormNAICSCodeSelect = <
	TFieldValues extends FieldValues,
	TTransformedValues = TFieldValues,
>({
	control,
	name,
	...props
}: FormNAICSCodeSelectProps<TFieldValues, TTransformedValues>) => (
	<Controller
		control={control}
		name={name}
		render={({ field: { ref, onBlur, ...fieldWithoutRef }, fieldState }) => (
			<NAICSCodeSelectInput {...props} {...fieldWithoutRef} error={fieldState.error} />
		)}
	/>
);
